
/* 属性注释 */
/*
treeConfig.majorKey:节点id字段名(必传)
name:节点显示名称字段名(必传)
treeConfig.dataList:树形列表节点数据(必传)
data:动态绑定的值
width:组件宽度，默认300
filter:是否开启过滤
operation:是否有操作按钮 treeRightMenu:[]右键菜单数据
示例:
   [
    { key: "add", title: "添加", lastShow: false },
    { key: "addc", title: "添加子节点", lastShow: false },
    { key: "delete", title: "删除", lastShow: true },
  ],


/* 方法注释 */
/*
@change:选中回调，返回点击节点
@refresh:刷新选中，参数为新的节点数据
@add:右键菜单方法,根据右键菜单数据中的key命名即可，对应调用相同key的菜单方法
*/

import { defineComponent, getCurrentInstance, ref } from "vue";
import JsxTemp from "./demo.jsx";
export default defineComponent({
  components: {
    JsxTemp,
  },
  name: "alpTree",
  //接受上级数据
  props: {
    treeRightMenu: {
      type: Array,
      default: [],
    },
    treeConfigs: {
      type: Object,
      default: () => {
        {
        }
      },
    },
  },
  computed: {
    treeConfig() {
      return Object.assign(
        {
          //是否展示图标
          showIcon: true,
          //是否展示连接线
          showLine: true,
          //页面标题
          pageTitle: "",
          //唯一标识
          majorKey: "id",
          //父级标识
          parentKey: "parentId",
          //是否过滤
          filter: true,
          //原生属性
          _attr: {},
          //显示名名称
          majorName: "name",
          //自定义icon图标列表
          iconList: [],
          //是否收缩
          isShrink: true,
          treeData: ref([]),
        },
        this.treeConfigs
      );
    },
  },
  data() {
    return {
      //图标列表
      iconList: ref([]),
      //图标插槽
      slotIconList: [],
      //过滤查询条件
      searchTreeKey: "",
      //展示数据
      treeData: [],
      //树形结构配置
      treeOptions: {
        //自定义宽度
        treeStyle: {
          width: this.treeConfigs.width || 300 + "px",
          minWidth: "200px",
        },
        //展开结构
        autoExpandParent: true,
        operation: true,
        //替换 treeNode 中 title,key,children 字段为 treeData 中对应的字段
        treeField: {
          children: "children",
          title: this.treeConfigs.majorName,
          key: "treeKey",
          value: "treeKey",
        },
      },
      treeKey: "treeKey",
      //展开状态
      expandState: true,
      //选中树节点
      selDept: [],
      //展开的树节点
      expandedKeys: [],
      //处理后的一级数据
      oneDimData: [],
      key:1
    };
  },
  setup(props, content) {
    const proxy: any = getCurrentInstance()?.proxy; //获取vue实例上下文
    return {};
  },
  watch: {
    //输入框数据变化进行过滤
    searchTreeKey: function (val) {
      const expanded = <Array<any>>[];
      (this as any).oneDimData.forEach((item) => {
        if (item[this.treeConfigs.majorName].indexOf(val) > -1) {
          expanded.push(item[this.treeKey]);
        }
      });
      (this as any).expandedKeys = expanded;
      this.searchTreeKey = val;
      this.treeOptions.autoExpandParent = true;
    },
    "treeConfigs.treeData": function (val) {
      if ((this as any).treeConfig.treeData.length !== 0)
        (this as any).treeConfig.treeData.forEach((item) => {
          item.treeKey =
            item[this.treeConfig.parentKey] +
            "-" +
            item[this.treeConfig.majorKey];
        });
      //设置展示源数据
      (this as any).oneDimData = this.treeConfig.treeData;
      //处理为树形结构
      let treeData = this.parseTreeData(this.treeConfigs.treeData);
      this.getIconList(treeData);
      this.treeData = treeData;
      this.expandedKeys = (this as any).treeConfig.treeData.map(
        (o) => o[this.treeKey]
      );
      this.key++
      // this.selDept = [this.treeData[0][this.treeConfig.majorKey]];
    },
    expandedKeys: function (val) {},
  },
  methods: {
    //使用右键对应菜单方法
    treeNodeContextMenuClick(data, menuKey) {
      this.$emit("rightMenuFunction", menuKey, data);
    },
    //展开
    open() {
      if (!this.expandState) {
        this.expandedKeys = this.oneDimData.map((o) => o[this.treeKey]);
        this.expandState = true;
      } else {
        this.expandedKeys = [];
        this.expandState = false;
      }
    },
    //刷新按钮
    refresh() {
      this.$emit("refresh", (res) => {
        if (res.length !== 0)
          res.forEach((item) => {
            item.treeKey =
              item[this.treeConfig.parentKey] +
              "-" +
              item[this.treeConfig.majorKey];
          });
        //设置展示源数据
        this.oneDimData = res;
        //处理为树形结构
        this.treeData = this.parseTreeData(res);
        this.expandedKeys = res.map((o) => o[this.treeKey]);
        // this.selDept = [this.treeData[0][this.treeConfig.majorKey]];
      });
    },
    //选中节点
    selTreeNode(nodeKey) {
      var targetNodeData = null;
      for (var i = 0; i < this.oneDimData.length; i++) {
        var one = this.oneDimData[i];
        if (one[this.treeKey] == nodeKey) {
          targetNodeData = one;
          break;
        }
      }
      //更新上级绑定数据
      this.$emit("update:data", targetNodeData);
      //上级绑定方法,返回选中对象
      this.$emit("change", targetNodeData);
    },
    //手动设置选中节点
    setSelectTreeNode(data) {
      let arr = <any>[];
      if (data[this.treeKey]) {
        arr.push(data[this.treeKey]);
      } else {
        (this as any).treeConfig.treeData.forEach((item) => {
          if (
            item[this.treeConfigs.majorName] === data[this.treeConfig.majorName]
          ) {
            arr.push(item[this.treeKey]);
          }
        });
      }
      this.selDept = JSON.parse(JSON.stringify(arr));
      //调用选中回调
      this.selTreeNode(this.selDept);
    },
    // 展开树节点
    onExpand(expandedKeys, val) {
      this.expandState = val.expanded;
      let arr = <any>[];
      (this as any).oneDimData.forEach((item) => {
        let treeKey = "";
        if (expandedKeys.indexOf(item[this.treeKey]) !== -1) {
          treeKey =
            item[this.treeConfig.parentKey] +
            "-" +
            item[this.treeConfig.majorKey];
          arr.push(treeKey);
        }
      });
      this.expandedKeys = arr;
      this.treeOptions.autoExpandParent = false;
    },
    //解析树结构
    parseTreeData(data) {
      var res = <any>[],
        map = {};
      if (Array.isArray(data)) {
        data.sort(
          (a, b) => a[this.treeConfig.majorKey] - b[this.treeConfig.majorKey]
        );
        data.forEach((one) => {
          var template = {
            ...one,
            children: [],
          };
          if (!map[one[this.treeConfig.parentKey]]) {
            res.push(template);
          } else {
            map[one[this.treeConfig.parentKey]].children.push(template);
          }
          if (!map[this.treeConfig.majorKey]) {
            map[one[this.treeConfig.majorKey]] = template;
          }
        });
      }
      return res;
    },
    //处理icon列表及icon插槽
    getIconList(treeData) {
      let that = this as any;
      let num = 0;
      //处理图标list数据
      this.treeConfig.iconList.forEach((item, index) => {
        let obj = <Object>{
          icon: item,
          key: "icon" + index,
        };
        (this as any).iconList.push(obj);
      });
      //处理图标数据
      const arrReduces = function (someArr) {
        for (let i = 0; i < someArr.length; i++) {
          if (that.treeConfig.iconList[num]) {
            someArr[i].slots = { icon: that.iconList[num].key || "" };
          }
          if (
            someArr[i].hasOwnProperty("children") &&
            Array.isArray(someArr[i].children) &&
            someArr[i].children.length !== 0
          ) {
            num++;
            arrReduces(someArr[i].children);
          }
        }
        num = that.treeConfig.iconList.length - num;
      };
      let iconList = <any>[];
      //获取图标插槽列表
      const getIcon = function (someArr) {
        for (let i = 0; i < someArr.length; i++) {
          if (someArr[i].slots) {
            iconList.push(someArr[i].slots);
          }
          if (
            someArr[i].hasOwnProperty("children") &&
            Array.isArray(someArr[i].children) &&
            someArr[i].children.length !== 0
          ) {
            getIcon(someArr[i].children);
          }
        }
      };
      //存在配置的列表处理，不存在直接获取icon列表
      if (this.treeConfig.iconList.length !== 0) {
        arrReduces(treeData);
      } else {
        getIcon(treeData);
      }
      //去掉重复icon数据
      if (iconList.length !== 0) {
        let obj = {};
        this.slotIconList = iconList.reduce(function (item, next) {
          obj[next.icon] ? "" : (obj[next.icon] = true && item.push(next));
          return item;
        }, []);
      }
    },
  },
  created() {
    if (this.treeConfig.majorKey === "" || this.treeConfigs.majorName === "") {
      (this as any).$message.warn("使用树形组件,请绑定keyId及name");
    }
    if ((this as any).treeConfig.treeData.length <= 0) {
      this.treeData = [];
      return;
    }
    if ((this as any).treeConfig.treeData.length !== 0)
      (this as any).treeConfig.treeData.forEach((item) => {
        item.treeKey =
          item[this.treeConfig.parentKey] +
          "-" +
          item[this.treeConfig.majorKey];
      });
    //设置展示源数据
    (this as any).oneDimData = this.treeConfig.treeData;
    //处理为树形结构
    let treeData = this.parseTreeData(this.treeConfigs.treeData);
    this.getIconList(treeData);
    this.treeData = treeData;
    this.expandedKeys = (this as any).treeConfig.treeData.map(
      (o) => o[this.treeKey]
    );
    // this.selDept = [this.treeData[0][this.treeConfig.majorKey]];
  },
});
